module.exports = __webpack_public_path__ + "media/promo/promo/images/bg-1-2adef42b497bed94c1ac4911f372f109.png";